import React from 'react';
import { useIntl } from 'umi';
import { Bubble } from 'tea-component';

// 引入 SVG 图标
import AISearchAgentIcon from '@/pages/home/assets/svg/nacHeader/ai-search-agent.svg';
import AISearchNavigationIcon from '@/pages/home/assets/svg/nacHeader/ai-search-navigation.svg';

/** AI 搜索类型 */
type TAISearchType = 'agent' | 'navigation';

/** AI 搜索列表项配置 */
interface IAISearchItemConfig {
  /** 类型标识 */
  type: TAISearchType;
  /** 图标 */
  icon: string;
  /** 图标 alt 文本 */
  iconAlt: string;
  /** 标签文案的 i18n key */
  labelKey: string;
  /** hover 提示文案的 i18n key */
  hoverKey: string;
}

/** 组件 Props */
interface IAISearchListProps {
  /** 输入框的值 */
  inputValue: string;
  /** 列表项点击回调 */
  onItemClick: (type: TAISearchType, keyword: string) => void;
}

/** AI 搜索列表项配置 */
const AI_SEARCH_LIST_CONFIG: IAISearchItemConfig[] = [
  {
    type: 'agent',
    icon: AISearchNavigationIcon,
    iconAlt: 'agent',
    labelKey: 'dbh_ai_search_agent_smart_qa',
    hoverKey: 'dbh_ai_search_agent_smart_qa_hover',
  },
  {
    type: 'navigation',
    icon: AISearchAgentIcon,
    iconAlt: 'navigation',
    labelKey: 'dbh_ai_search_page_navigation',
    hoverKey: 'dbh_ai_search_page_navigation_hover',
  },
];

const AISearchList: React.FC<IAISearchListProps> = ({ inputValue, onItemClick }) => {
  const { formatMessage } = useIntl();

  /** 列表项点击处理 */
  const handleItemClick = (e: React.MouseEvent, type: TAISearchType) => {
    e.stopPropagation();
    onItemClick(type, inputValue);
  };

  return (
    <ul className="dbh-ai-search-list">
      <li className="dbh-ai-search-list__title tea-list__label">
        {formatMessage({ id: 'dbh_ai_search' })}
      </li>
      {AI_SEARCH_LIST_CONFIG.map((item) => (
        <li
          key={item.type}
          className="dbh-ai-search-list__item"
          onClick={(e) => handleItemClick(e, item.type)}
        >
          <img
            className="dbh-ai-search-list__item-icon"
            src={item.icon}
            alt={item.iconAlt}
          />
          <span className="dbh-ai-search-list__item-text">
            <span className="dbh-ai-search-list__item-keyword">
              {inputValue || '...'}
            </span>
            <span className="dbh-ai-search-list__item-separator"> - </span>
            <Bubble
              overlayClassName="dbh-ai-search-list__item-label-bubble"
              arrowPointAtCenter
              placement="right"
              dark
              content={formatMessage({ id: item.hoverKey })}
            >
              <span className="dbh-ai-search-list__item-label">
                {formatMessage({ id: item.labelKey })}
              </span>
            </Bubble>
          </span>
        </li>
      ))}
    </ul>
  );
};

export default AISearchList;
